export default __webpack_public_path__ + "static/media/head03_vi_sp.bebbd026.png";